<template>
  <div id="app">
        <main-header></main-header>
        <router-view/>
        <main-footer></main-footer>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import MainHeader from '@/components/partials/MainHeader'
import MainFooter from '@/components/partials/MainFooter'
// import { page } from 'vue-analytics'

export default {
  name: 'App',
  components: {
    MainHeader,
    MainFooter
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Tinos:400,700');
  @import "../node_modules/bootstrap/scss/bootstrap.scss";
  @import "../src/assets/styles/bootstrap.scss";
  @import "../src/assets/styles/main.scss";

  body {
      margin: 0 !important;
  }
  .bm-menu{
      background-color: $primary-font-color-2 !important;
  }
  .bm-item-list{
      width: 100vw !important;
  }
  .bm-burger-button{
      display: none;
  }
  @media screen and (max-width: $lg-breakpoint){
      .bm-burger-button {
          display: block;
      }
      .bm-burger-bars{
          background-color: $primary-font-color-2 !important;
      }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue